/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Lines_Per_EventInputs */

const en_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Lines Per Event`)
};

const fr_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max lignes par événement`)
};

const de_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeilen pro Veranstaltung`)
};

const it_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di linee per evento`)
};

const ru_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество линий на мероприятие`)
};

const es_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de líneas por evento`)
};

const zh_cn2_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每场比赛最多行数`)
};

const ja_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントあたりの最大行数`)
};

const hi_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति इवेंट अधिकतम लाइनें`)
};

const pt_pt2_max_lines_per_event = /** @type {(inputs: Max_Lines_Per_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de linhas por evento`)
};

/**
* | output |
* | --- |
* | "Max Lines Per Event" |
*
* @param {Max_Lines_Per_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_lines_per_event = /** @type {((inputs?: Max_Lines_Per_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Lines_Per_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_max_lines_per_event(inputs)
	if (locale === "de") return de_max_lines_per_event(inputs)
	if (locale === "it") return it_max_lines_per_event(inputs)
	if (locale === "ru") return ru_max_lines_per_event(inputs)
	if (locale === "es") return es_max_lines_per_event(inputs)
	if (locale === "zh-CN") return zh_cn2_max_lines_per_event(inputs)
	if (locale === "ja") return ja_max_lines_per_event(inputs)
	if (locale === "hi") return hi_max_lines_per_event(inputs)
	if (locale === "pt-PT") return pt_pt2_max_lines_per_event(inputs)
	return en_max_lines_per_event(inputs)
});